/**
 * Mock 模块：heart_voyage_invite_pending
 * 默认 3 条对齐 state-default；单条对齐 state-single。
 * @see mockMd/heart_voyage_invite_pending.md
 */
import {storiesAvatar} from '../components/PendingInviteModal/stories-images'
import {PendingInviteStatus, RelationType} from '../types'
import type {HeartVoyagePendingInviteItem, InvitePendingData} from '../types'

const MOCK_USER_AVATAR = storiesAvatar

const mockPending = (
  invite_id: string,
  id: number
): HeartVoyagePendingInviteItem => ({
  invite_id,
  rel_type: RelationType.Couple,
  status: PendingInviteStatus.Inviting,
  expire_at: 1710000000,
  peer: {
    id,
    name: 'user name',
    zy_id: '102938475',
    avatar: MOCK_USER_AVATAR,
    gender: 1,
  },
})

/** @see mockMd/heart_voyage_invite_pending.md */
export const HeartVoyageInvitePendingMock: InvitePendingData = {
  err_msg: '',
  pending: [
    // mockPending('inv_abc123', 10002),
    // mockPending('inv_abc124', 10003),
    // mockPending('inv_abc125', 10004),
  ],
}

export const HeartVoyageInvitePendingSingleMock: InvitePendingData = {
  err_msg: '',
  pending: [mockPending('inv_abc123', 10002)],
}

export const HeartVoyageInvitePendingEmptyMock: InvitePendingData = {
  err_msg: '',
  pending: [],
}

export const HeartVoyageInvitePendingSearchMock: InvitePendingData = {
  err_msg: '',
  pending: [mockPending('inv_abc123', 123)],
}
